import { render, staticRenderFns } from "./LScreenType.vue?vue&type=template&id=0b281efc&"
import script from "./LScreenType.vue?vue&type=script&lang=ts&"
export * from "./LScreenType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports